import {
  VolopFunctions,
  fetchVolopFunctions as apiFetchVolopFunctions,
} from 'api/orgs';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '..';
import { setError } from './error';

// Types

export type State = VolopFunctions | null | undefined;

export type Action = {
  type: 'VOLOP_FUNCTIONS_SET';
  volopFunctions: VolopFunctions | null | undefined;
};

// Reducer

// eslint-disable-next-line import/no-default-export
export default function volopFunctionsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = null,
  action: Action
) {
  switch (action.type) {
    case 'VOLOP_FUNCTIONS_SET': {
      return action.volopFunctions;
    }

    default:
      return state;
  }
}

// Actions

export const fetchVolopFunctions =
  () => (dispatch: Dispatch, getState: GetState) => {
    if (getState().volopFunctions) {
      return;
    }

    apiFetchVolopFunctions()
      .then((volopFunctions) => {
        dispatch({
          type: 'VOLOP_FUNCTIONS_SET',
          volopFunctions,
        });
      })
      .catch(setError);
  };
